import React from "react";
import { withRouter } from "react-router-dom";
import { getPlanGate, planStepUrl, isExemptPath } from "../functions/plan-gate";

// Shell lockdown for Shopify-installed workspaces without a Commerce plan (2026-09-26):
// adds body.plan-gated (sidebar + top-bar controls hidden, see sass/v2/_plan-gate.scss)
// and bounces any route except the plan step back to it. Re-evaluated on every route
// change; fails OPEN when Billing can't answer.
class PlanGate extends React.Component {
  componentDidMount() {
    this._alive = true;
    this.check(this.props.location);
    this._unlisten = this.props.history.listen(loc => this.check(loc));
  }
  componentWillUnmount() {
    this._alive = false;
    if (this._unlisten) this._unlisten();
  }
  async check(loc) {
    const path = loc && loc.pathname || "/";
    if (String(path).toLowerCase().indexOf("/auth/") === 0) return;
    let g = null;
    try {
      g = await getPlanGate();
    } catch (e) {
      g = null;
    }
    if (!this._alive) return;
    const gated = !!(g && g.gated);
    try {
      document.body.classList.toggle("plan-gated", gated);
    } catch (e) {/* ssr */}
    if (gated && !isExemptPath(path)) this.props.history.replace(planStepUrl(g.shop));
  }
  render() {
    return null;
  }
}
export default withRouter(PlanGate);